import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface IWatchlistStateSlice {
  watchlist: IWatchlist[];
  watchlistState: IReduxLoadingState;
  loadingList: number[];
}

const name = "watchlist";

export const initialState: IWatchlistStateSlice = {
  watchlist: [],
  watchlistState: "pending",
  loadingList: [],
};

export const watchlistSlice = createSlice({
  name,
  initialState,
  reducers: {
    updateWatchlist(
      state,
      action: PayloadAction<{
        watchlist?: IWatchlist[];
        watchlistState?: IReduxLoadingState;
        addLoadingItem?: number;
      }>
    ) {
      if (action.payload.watchlist) state.watchlist = action.payload.watchlist;
      if (action.payload.addLoadingItem) {
        state.loadingList = [
          ...state.loadingList,
          action.payload.addLoadingItem,
        ];
      }
      if (action.payload.watchlistState)
        state.watchlistState = action.payload.watchlistState;
    },
    removeWatchlistLoading(
      state,
      action: PayloadAction<{
        watchlist?: IWatchlist[];
        watchlistState?: IReduxLoadingState;
        removeLoadingItem?: number;
      }>
    ) {
      if (action.payload.watchlist) state.watchlist = action.payload.watchlist;
      if (action.payload.removeLoadingItem) {
        state.loadingList = state.loadingList.filter(
          (item) => item !== action.payload.removeLoadingItem
        );
      }
      if (action.payload.watchlistState)
        state.watchlistState = action.payload.watchlistState;
    },
  },
});

export const { updateWatchlist, removeWatchlistLoading } =
  watchlistSlice.actions;

const persistedReducer = persistReducer(
  { key: name, storage: storage, whitelist: ["watchlist"] },
  watchlistSlice.reducer
);

export default persistedReducer;
